// extracted by mini-css-extract-plugin
module.exports = {"memed-container":"memed-container--3hjfH"};